import { rule, messages } from 'vue-mc/validation';
import moment from 'moment';

const dateValidator = rule({
	name: 'dateValidator',
	test: (date) => {
		const selectedDate = moment(date);
		const minDate = moment('1970-01-01');
		//const maxDate = moment().add(15, 'days');
		
		if (!selectedDate.isValid) {
			return false;
		}
		
		return selectedDate.isAfter(minDate, undefined);
	},
});

messages.set('dateValidator', 'Date must be set and cannot be older than 1970');

export default dateValidator;
